module.exports = __webpack_public_path__ + "img/Vue-Covid19TestApp-desktop.05fddda0.png";